function getAssetsUrl(url: string): string {
  return `/sitefiles/assets/${url}`;
}

export default getAssetsUrl;
